import { createSlice } from '@reduxjs/toolkit';
import { fetchActivityLogsForUserProjectDate } from './thunks/fetchActivityLogsForUserProjectDate.thunk';

const emptyDialog = {
  open: false,
  userId: null,
  projectId: null,
  date: null,
};

const initialState = {
  dialog: emptyDialog,
  items: [],
  loading: false,
  error: null,
};

const activityLogSlice = createSlice({
  name: 'activityLog',
  initialState,
  reducers: {
    openActivityLogDialog: (state, action) => {
      const { userId, projectId, date } = action.payload || {};
      state.dialog = { open: true, userId, projectId, date };
      state.items = [];
      state.error = null;
    },
    closeActivityLogDialog: (state) => {
      state.dialog = emptyDialog;
      state.items = [];
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchActivityLogsForUserProjectDate.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        fetchActivityLogsForUserProjectDate.fulfilled,
        (state, action) => {
          state.loading = false;
          state.items = action.payload || [];
        }
      )
      .addCase(
        fetchActivityLogsForUserProjectDate.rejected,
        (state, action) => {
          state.loading = false;
          state.error =
            action.error?.message || 'Failed to load activity logs';
        }
      );
  },
});

export const { openActivityLogDialog, closeActivityLogDialog } =
  activityLogSlice.actions;

export const selectActivityLogDialog = (state) => state.activityLog.dialog;
export const selectActivityLogItems = (state) => state.activityLog.items;
export const selectActivityLogLoading = (state) => state.activityLog.loading;

export default activityLogSlice.reducer;
